import { render, staticRenderFns } from "./ReviewTraces.vue?vue&type=template&id=a63bfd4a&"
import script from "./ReviewTraces.vue?vue&type=script&lang=ts&"
export * from "./ReviewTraces.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewTraces.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports